// stores
import * as ContractStageStore from '../../../../../redux/middleware/ContractStageMiddleware';
import * as ContractStore from '../../../../../redux/middleware/ContractMiddleware';

// models
import { AppState } from "../../../../../redux/reducers";
import { Contract } from "../../../../../models/Entities/Contracts/Contract";
import { ContractStage } from "../../../../../models/Entities/Contracts/ContractStage";
import { ErrorType } from '../../../../../models/HttpError';
import { Protocol } from '../../../../../models/Entities/Protocols/Protocol';


interface IProps {
    ProtocolId: number;
    StageId: number;
    /** Adenda de la etapa según el contrato; el payload de visitas del protocolo no la trae. */
    AddendumId?: number;
    ExcludedVisitIds?: number[];
}
  
interface ConnectedProps {
    // getting contract
    isLoagingContract: boolean;
    contractLoadedSuccessfully: boolean;
    failOnLoadingContract: boolean;
    errorLoadingContract: ErrorType | undefined;

    // getting contract stages
    isLoadingStages: boolean;
    stagesLoadedSuccessfully: boolean;
    failOnLoadingStages: boolean;
    errorLoadingStages: ErrorType | undefined;

    // Linking stage
    isLinkingStage: boolean;
    stageLinkedSuccessfully: boolean;
    failOnLinkingStage: boolean;
    errorLinkingStage: ErrorType | undefined;

    Protocol: Protocol;
    Stage: ContractStage;

}
  
interface DispatchProps {
    GetContractById: typeof ContractStore.actionCreators.GetContractById;
    GetContractStageById: typeof ContractStageStore.actionCreators.GetContractStageById;
    LinkStageToAProtocolVisit: typeof ContractStageStore.actionCreators.LinkStageToAProtocolVisit
}
  
export type Props = IProps & ConnectedProps & DispatchProps;
  
export const mapStateToProps = (state: AppState, ownProps: IProps) => {
    
    const currentProtocol = state.MedicalProtocols?.list?.find((item: Protocol) => item.id === ownProps.ProtocolId) || undefined;
    const currentStage = currentProtocol?.ContractVisits?.find((item: ContractStage) => item.id === ownProps.StageId) || undefined;

    return {
        isLoagingContract: state.Contract?.isLoadingOne || false,
        contractLoadedSuccessfully: state.Contract?.successLoadingOne || undefined,
        failOnLoadingContract: state.Contract?.failOnLoadingOne || false,
        errorLoadingContract: state.Contract?.error || undefined,

        isLoadingStage: state.ContractStage?.isLoadingOne || false,
        stageLoadedSuccessfully: state.ContractStage?.successLoadingOne || undefined,
        failOnLoadingStage: state.ContractStage?.failOnLoadingOne || false,
        errorLoadingStage: state.ContractStage?.error || undefined,

        isLinkingStage: currentStage?.isLinkingToAProtocolVisit || false,
        stageLinkedSuccessfully: currentStage?.linkedToAProtocolVisitSuccessfully || undefined,
        failOnLinkingStage: currentStage?.failOnLinkingToAProtocolVisit || false,
        errorLinkingStage: state.ContractStage?.error || undefined,

        Protocol: currentProtocol,
        Stage: currentStage
    }    
};
  
export const mapDispatchToProps = {
    ...ContractStageStore.actionCreators,
    ...ContractStore.actionCreators
};